module.exports = ":host {\n  display: block;\n  width: 100%; }\n"